import fr from './fr.json';
import en from './en.json';
import pt from './pt.json';
import it from './it.json';
import ru from './ru.json';
import zh from './zh.json';

const translations = {
  fr,
  en,
  pt,
  it,
  ru,
  zh
};

export default translations;